import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e4cd3f0a&scoped=true"
import script from "./detail.vue?vue&type=script&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=e4cd3f0a&prod&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=e4cd3f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cd3f0a",
  null
  
)

export default component.exports